import React from 'react';

import { Table,TableHeaderCell} from 'semantic-ui-react'

import { AnalysisError} from '../../shared/interfaces'

import { ErrorDetailsRow } from './ErrorDetailsRow'

import {useTranslation} from 'react-i18next'

interface IProps {
  details:Array<AnalysisError>
}

export const ErrorDetails = ({
  details = []
  } :IProps
)=>{
  const { t } = useTranslation();
  if (details.length===0) {
    return <div></div>
  } else {
    
    return <Table>
      <Table.Header>
        <Table.Row>
        <TableHeaderCell>
            {t("errors.ui.category")}
          </TableHeaderCell>
          <TableHeaderCell>
            {t("errors.ui.component")}
          </TableHeaderCell>
          <TableHeaderCell>
            {t("errors.ui.details")}
          </TableHeaderCell>
          <TableHeaderCell>
            {t("errors.ui.lineNo")}
          </TableHeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {details.map(err => {
          return <ErrorDetailsRow detail={err} />
        })}
      </Table.Body>
    </Table>
  }
  
}